<template>
  <div class="text-center py-5 bg-light">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="feather feather-clock"
    >
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
    <p class="lead mt-4">
      {{ 'This lecture will be available on' | translate }}
    </p>
    <h4>{{ component.left }}</h4>
  </div>
</template>

<script>
export default {
  props: ['component'],
}
</script>

<style></style>
